import React from 'react';
import CompanyDetailQuery from '@admin/graphql-api/_old_queries/CompanyDetailQuery';
import {graphql} from '@apollo/client/react/hoc';
import {MiniPlayer} from '@core/components/AudioMiniPlayer';
import Episode from '@core/components/Episode';
import {Element} from '@core/style';
import Loading from '@core/ui/Loading';

class CompanyDetail extends React.Component {
  render() {
    const {
      data: {loading, admin},
    } = this.props;

    if (loading) {
      return <Loading absolute />;
    }

    const {company} = admin;

    return (
      <div>
        <h3>{company.name}</h3>
        <div>
          {company.ads.map((ad) => {
            return (
              <Element key={ad.id}>
                <div>
                  {ad.placements.map((placement) => {
                    return (
                      <Episode key={placement.id} episode={placement.episode} />
                    );
                  })}
                </div>
                <MiniPlayer enclosure={ad} />
              </Element>
            );
          })}
        </div>
      </div>
    );
  }
}

export default graphql(CompanyDetailQuery, {
  options: ({
    match: {
      params: {companyId},
    },
  }) => ({
    variables: {
      id: companyId,
    },
  }),
})(CompanyDetail);
